// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__f5Phf","item":"PaymentsMobile_item__3iPGC","label":"PaymentsMobile_label__1t85y","amount":"PaymentsMobile_amount__2Y3dR"};